export default __webpack_public_path__ + "static/typography-image-z-cff42b4a73c4448325166c4cf39e2cbf09a0ad8e2991c9ca045be65c676c1b5a.png";